export default __webpack_public_path__ + "static/media/decor8.41e2e6d3.webp";